import { useQuery } from '@tanstack/react-query';
import { financialRecoveryService, GET_RESOLVED_CASES } from '@/api';
import { LoaderScreen } from '@/components/common';
import { EmptyStateCaseDetails } from '@/components/dashboard';
import { CardContainer } from '@/components/dashboard';
import Icons from '@/const/icons';
import { FinancialCard } from './FinancialCard';

interface Props {
	filterValue: string | undefined;
}

export const FinancialCasesList: React.FC<Props> = ({ filterValue }) => {
	const {
		data: listCases,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [GET_RESOLVED_CASES, filterValue],
		queryFn: () =>
			financialRecoveryService.getAll({
				year: filterValue ? Number(filterValue) : undefined,
			}),
	});

	const list = listCases?.data.items || [];
	const loading = isLoading || isFetching;

	return (
		<CardContainer
			title="Resolved Cases"
			icon={Icons.folderCloudGreen}
			iconWidth={70}
			iconHeight={62}
			description="Successfully completed and closed cases."
			classNameContent={'h-full md:h-[48vh] 3xl:h-[50vh]'}
		>
			{loading && <LoaderScreen />}
			{!loading && list.length === 0 && (
				<EmptyStateCaseDetails text="No financial recovery has occurred to date." />
			)}

			{!loading && list.length > 0 && (
				<div className="space-y-4">
					{list.map((item, index) => (
						<FinancialCard key={index} {...item.case} />
					))}
				</div>
			)}
		</CardContainer>
	);
};
